import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Public API endpoints
export const publicAPI = {
  // Motorhomes
  getMotorhomes: async () => {
    const response = await api.get('/motorhomes');
    return response.data;
  },
  
  getMotorhomeBySlug: async (slug) => {
    const response = await api.get(`/motorhomes/${slug}`);
    return response.data;
  },
  
  // Reviews
  getReviews: async () => {
    const response = await api.get('/reviews');
    return response.data;
  },

  getGoogleReviews: async () => {
    const response = await api.get('/google-reviews');
    return response.data;
  },
  
  // FAQs
  getFAQs: async () => {
    const response = await api.get('/faqs');
    return response.data;
  },
  
  // Servicing
  getServicing: async () => {
    const response = await api.get('/servicing');
    return response.data;
  },
  
  // Gallery
  getGalleryImages: async () => {
    const response = await api.get('/gallery');
    return response.data;
  },
  
  // Settings
  getSettings: async () => {
    const response = await api.get('/settings');
    return response.data;
  },
};

export default api;
